module.exports = __webpack_public_path__ + "eeafc41f4a9d95fd966ea9e5d052c1cd.png";